import { Alert, Typography } from '@mui/material';
import { estimateUnavailableLabels } from '@/features/operations/labels';
import { usePriceDisplay } from '@/features/operations/PriceDisplayProvider';
import type { QuotationRequestItem } from '@/features/operations/types';

/**
 * What the counter tells the person in front of it, right after registering their request: the
 * amount, or why there is none and what happens next.
 */
export function IntakeOutcomeAlert({ quotation }: { quotation: QuotationRequestItem }) {
  const { formatMoney } = usePriceDisplay();
  return (
    <Alert severity={quotation.estimate ? 'success' : 'warning'}>
      <Typography variant="subtitle2" gutterBottom>
        Solicitud {quotation.id} registrada · {quotation.brand} {quotation.model}
      </Typography>
      {quotation.estimate ? (
        <>
          <Typography variant="h6">
            {formatMoney(quotation.estimate.amountMinor, quotation.estimate.currency)}
          </Typography>
          <Typography variant="body2">
            Es una estimación no vinculante; el precio final se define después de revisar el equipo
            presencialmente.
          </Typography>
        </>
      ) : (
        // Silence is fine on the web, where nobody is waiting in front of you. Here it leaves
        // whoever is attending with nothing to say, so the reason and the next step are both
        // spelled out.
        <Typography variant="body2">
          No pudimos estimar un monto:{' '}
          {estimateUnavailableLabels[quotation.estimateUnavailableReason || ''] ||
            quotation.estimateUnavailableReason}
          . La solicitud quedó registrada igual: coordiná la revisión presencial y el precio se
          define ahí.
        </Typography>
      )}
    </Alert>
  );
}
